// pages/SingleCheckout.jsx
import { useEffect, useMemo, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import axios from '../../backendClient';
import SingleGA from './SingleGA';
import { redirect, useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';




//export default function SingleGAParent({ eventId: propEventId, slug: propSlug }) {
  const SingleGAParent = ({ eventId: propEventId, slug: propSlug }) => {
  const stripePromise = loadStripe('pk_live_51NtjiEID4DrgC8ZC2oAC6Jt3mAvjhzeQXr8rw19wLUW33J7eoVd9V7kvUBfqUeGoea7eJ0DkqNLsfAgQv6zDOUnb00AXQbueN4');
  const [eventId, setEventId] = useState(propEventId || null);
  const [slug, setSlug] = useState(propSlug || null);
  const [discountCents, setDiscountCents] = useState(0); 
  const [currency, setCurrency] = useState('usd');
  const navigate = useNavigate(); 
  const location = useLocation(); 
  const incoming = location.state;
  const {currentUser} = useSelector(state => state.user);
  const [gaCents, setGaCents] = useState(incoming?.cost || 0);

  const [err, setErr] = useState('');
  const [applying, setApplying] = useState(false);
  const [promoCode, setPromoCode] = useState('');

  const [status, setStatus] = useState('processing');

  const redirectState = useMemo(() => ({
    source: 'event',
    slug: incoming?.slug,
    eventId: incoming?.eventId ?? null,
    returnAfterLogin: `/single/${incoming?.slug}`,
    returnAfterRegister: `/single/${incoming?.slug}`,
    cost: incoming?.cost,
    title: incoming?.title,
    isLead: incoming?.isLead
  }), [incoming]);



  // let redirectState = {
  //   source: 'event',
  //   slug: incoming?.slug,
  //   eventId: incoming?.eventId ?? null,
  //   returnAfterLogin: `/single/${incoming?.slug}`,
  //   returnAfterRegister: `/single/${incoming?.slug}`,
  //   cost: incoming?.cost,
  //   title: incoming?.title,
  //   isLead: incoming?.isLead
  // };
        
//   useEffect(() => {
//           if (incoming) {
//               redirectState = 
//               {
//                  source: 'event',
//                  slug: incoming.slug,
//                  eventId: incoming.eventId ?? null,
//                  returnAfterLogin: `/single/${incoming.slug}`,
//                  returnAfterRegister: `/single/${incoming.slug}`,
//                  // event: incoming.event
//                };
//           }
//         }, [location.state]);

 //   // 🔐 route to login if no user

 useEffect(() => {
  // 2. SAVE IMMEDIATELY (This happens before the API call finishes)
  localStorage.setItem('IM_redirect', JSON.stringify(redirectState));

  if (!currentUser) {
      navigate('/login', { replace: true, state: redirectState });
    }

  }, [currentUser, navigate, redirectState]);



  // fallback from localStorage redirect
   useEffect(() => {
     if (!eventId || !slug) {
       try {
        const rs = JSON.parse(localStorage.getItem('IM_redirect') || 'null');
         if (rs?.eventId) setEventId(rs.eventId);
         if (rs?.slug) setSlug(rs.slug);
       } catch {}
     }
   }, [eventId, slug]);

    // Optional: validate/preview promo with server so UI matches final charge
    const applyPromo = async () => {
        if (!promoCode) { setDiscountCents(0); return; }
        if (!eventId) return;
        setApplying(true); setErr('');
        try {
          // Recommended tiny endpoint (see below): returns { base_cents, discount_cents, total_cents, currency }
          const { data } = await axios.post('/api/payments/previewPromo', {
            eventId,
            promoCode: promoCode.trim() || null,
          });
          setDiscountCents(data.discount_cents || 0);
          // Optionally also setGaCents(data.base_cents) if server returns it
          //we will simply get this from backend assuming they applied promo properly 
          //final payment will just pass in promo and eventId they submitted to get the final price 
          //on server only 
        } catch (e) {
          setDiscountCents(0);
          setErr(e?.response?.data?.error || 'Promo not valid.');
        } finally {
          setApplying(false);
        }
      };

//should run automatically unless overSet by discount 
  useEffect(() => {
    let cancel = false;
    (async () => {
      if (!eventId) return;
      try {
        // minimal endpoint to read GA price; or fold into your existing event GET
        const { data } = await axios.get('/api/events/getEventPrice'); 
        // expect { ga_amount_cents, currency, slug }
        if (!cancel) {
          setGaCents(data.ga_price);
          setCurrency((data.currency || 'usd').toLowerCase());
          if (!slug && data.slug) setSlug(data.slug);
        }
      } catch {
        // allow form to render even if price missing; your form shows $0 until known
        if (!cancel) { setGaCents(null); }
      }
    })();
    return () => { cancel = true; };
  }, [eventId]);

  const appearance = useMemo(() => ({ theme: 'flat' }), []);
  const elementsOptions = useMemo(() => ({
    mode: 'payment',
    paymentMethodCreation: 'manual',
    currency: 'usd',
    amount: 3000,
    appearance,
  }), []);
  
 
  return (
    <Elements stripe={stripePromise} options={elementsOptions}>
      <SingleGA
        eventId={eventId}
        slug={slug}
        eventTitle={redirectState?.title}
        // discountPrice = {discountCents ?? 0}
        // ticketLabel="GA"
        ticketAmountCents={redirectState?.cost ?? 0} // purely for display; server is authoritative
        // currency={currency}
        isLead={redirectState?.isLead}
      />
    </Elements>
  ); 
}

export default SingleGAParent; 